import { useCallback, useEffect, useState } from 'react';
import { useGetHelpByUrlAndSlugQuery } from '../redux/services/help.jsx';
// You need these imports
import { QuestionCircleFilled } from '@ant-design/icons'; // or wherever your icon comes from
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom'; // for t function

// for navigate

function useHelpWithModal() {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const [headerTitle, setHeaderTitle] = useState('');
  const [mainActions, setMainActions] = useState([]);
  const [content, setContent] = useState('');
  const { t } = useTranslation();

  const processCurrentUrl = useCallback(() => {
    const segments = location.pathname.split('/').filter(Boolean);

    const baseSegments = segments.filter(segment => {
      return !/^\d+$/.test(segment) && // Remove pure numbers
        !/^[a-f0-9-]{36}$/.test(segment); // Remove UUIDs
    });
    return `/${baseSegments.join('/')}`;

  }, [location.pathname]);


  const {
    data,
    isLoadingHelp,
    error
  } = useGetHelpByUrlAndSlugQuery(
    { url: processCurrentUrl(), slug: null }
  );

  const openModal = useCallback(() => {
    setIsVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsVisible(false);
  }, []);

  useEffect(() => {
    if (data) {
      setMainActions([
        {
          onClick: () => openModal(),
          title: t('Zobraziť pomoc'),
          icon: <QuestionCircleFilled/>,
        },
      ]);
    } else {
      setMainActions([]);
    }
  }, [data, openModal, t]);

  useEffect(() => {
    if (data) {
      setHeaderTitle(data.title)
      setContent(data.content)
    }
  }, [data]);

  return {
    helpDetail: {
      data,
      isLoadingHelp,
      error
    },
    helpActions: mainActions,
    modal: {
      openModal,
      closeModal,
      props: {
        visible: isVisible,
        headerTitle,
        content,
        toggle: closeModal,
      }
    }
  };
}

export default useHelpWithModal;
